import React from 'react';

const SectionHeader = ({ icon, title, count }) => (
  <div className="d-flex align-items-center gap-2 mb-3 pb-2 border-bottom">
    <span className="material-icons text-secondary">{icon}</span>
    <h5 className="fw-bold mb-0">{title}</h5>
    {count !== undefined && (
      <span className="text-secondary ms-1" style={{ fontSize: '0.95rem' }}>
        ({count} {count === 1 ? 'result' : 'results'})
      </span>
    )}
  </div>
);

export default SectionHeader;
